module.exports = __webpack_public_path__ + "img/new-baby-min.92b79972.png";